"use client";
import React, { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useDCAuth } from "./hooks/useDCAuth";

interface ProtectedRouteProps {
  children: React.ReactNode; // 👈 Tip agregado
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = "/login",
}) => {
  const router = useRouter();
  const { isAuthenticated, loading } = useDCAuth();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      router.replace(redirectTo);
    }
  }, [loading, isAuthenticated, redirectTo]); // router es estable, no necesita estar en deps

  if (loading) return null;
  return <>{isAuthenticated ? children : null}</>;
};
